module.exports = __webpack_public_path__ + "static/media/pl.aa3ad8a9.svg";